module.exports = __webpack_public_path__ + "img/insta-1.08a89e38.jpg";